/* eslint-disable no-use-before-define */ 
import { Page, TitleNbr, Paragrapth ,TitlePage} from '@orientaction/components';
import { MarginContainer } from '@orientaction/commons';
import { Fragment } from 'react';
import { context } from './context';

const Page21 = (props: any) => {

    return (
        <Page id={21}>

            <div style={{ textAlign: 'center' }}>

                <TitlePage>
                    RISQUES ET OPPORTUNITÉS <br />
                    D’UNE RECONVERSION
                </TitlePage>

                {
                    context.map((item: any, sectionIndex: number) => (
                        <Fragment key={item.id ?? sectionIndex}>
                            <MarginContainer>
                                <TitleNbr number={item.id} text={item.title} />
                            </MarginContainer>

                            {
                                item.listContext.map((itemList: any, listIndex: number) => (
                                    <MarginContainer key={itemList.title ?? listIndex}>

                                        <Paragrapth align='start'>

                                            <Paragrapth align='start' bold={true} colorBlue={true}>
                                                {itemList.title} :
                                            </Paragrapth> {itemList.content}
                                        </Paragrapth>

                                    </MarginContainer>
                                ))
                            }

                        </Fragment>
                    ))
                }

            </div>

        </Page>
    );
};

export default Page21;
